/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable eqeqeq */
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Button, Input, Modal } from 'antd';
import { VscFolder } from 'react-icons/vsc';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../../constants/service.types';
import { NOTIFIES } from '../../../constants/system.keys';
import {
  openMessage,
  socketEmitEvent,
  clearListGroupByParentGroup,
  clearGroupAccountMember,
} from '../../../redux/actions';
import Folder from '../Folder';
import AddGroupMember from '../Modals/AddGroupMember';
import { beeXLogger } from '../../../helpers/logger';

const { Search } = Input;

const removeAccents = (str) => {
  return str
    ? str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D')
    : '';
};

const GroupMembersTab = ({
  namespace,
  isAdmin,
  currentTab,
  accountByNamespaceData,
  searchKeyword,
  setSearchKeyword,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    accountByNamespace,
    groupMembers: listGroupMembers,
    updateGroupMembers,
    deleteGroupMembers,
    listGroupByParentGroup,
    addGroupMembers,
    checkRemoveGroup,
    accountGroupMembers,
  } = useSelector((state) => state);

  const [groupMemberTabLoading, setGroupMemberTabLoading] = useState(false);
  const [groupMembersDefault, setGroupMembersDefault] = useState();
  const [groupMembers, setGroupMembers] = useState();
  const [searchValue, setSearchValue] = useState('');
  const [dataArr, setDataArr] = useState({});
  const [visibleGroupMembers, setVisibleAddGroupMembers] = useState(false);
  const [key, setKey] = useState(Math.random());

  const [membersGroup, setMembersGroup] = useState([]);
  const [idParentSelected, setIdParentSelected] = useState(null);
  const [recordSelected, setRecordSelected] = useState(null);

  const [explorerDataList, setExplorerDataList] = useState([]);
  const [valueInput, setValueInput] = useState('');
  const [progressMap, setProgressMap] = useState({});
  const [queue, setQueue] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const isAuth = useSelector((state) => state.isAuth);

  const [
    isPopupConfirmDeleteGroupVisible,
    setIsPopupConfirmDeleteGroupVisible,
  ] = useState(false);
  const [
    isPopupConfirmDeleteMemberVisible,
    setIsPopupConfirmDeleteMemberVisible,
  ] = useState(false);

  const [dataRemoveGroup, setDataRemoveGroup] = useState([]);

  useEffect(() => {
    if (isDisabled) {
      document.getElementsByTagName('body')[0].style.pointerEvents = 'none';
    } else {
      document.getElementsByTagName('body')[0].style.pointerEvents = 'auto';
    }
  }, [isDisabled]);

  const handleFocus = () => {
    setIdParentSelected(null);
  };

  const handleInputChange = (e) => {
    setValueInput(e.target.value);
  };

  const onAdd = (e) => {
    if (e.keyCode === 13 || e.type === 'click') {
      setIdParentSelected(null);
      if (!valueInput) return;
      const requestId = new Date().getTime();
      const values = valueInput;
      const dataList = null;
      onCreateGroupMembers(requestId, values, dataList);
    }
  };

  const handleAddNewGroup = (folderId, itemName, isFolder) => {
    setIdParentSelected(folderId);
    if (isFolder) {
      let data = {
        namespace,
        name: itemName,
        parentGroupId: folderId,
        accountInfos: [],
      };
      let dataObj = {
        appServiceType: SERVICE.ADD_GROUP_MEMBER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  };

  useEffect(() => {
    if (addGroupMembers) {
      setExplorerDataList((state) => {
        const updateItemRecursively = (items) =>
          items.map((item) => {
            if (item.id === addGroupMembers.data.group.parentGroupId) {
              return {
                ...item,
                items: [
                  ...(item.items || []),
                  {
                    id: addGroupMembers.data.group.id,
                    name: addGroupMembers.data.group.name,
                    isFolder: true,
                    items: [],
                  },
                ],
              };
            } else if (item.items && item.items.length > 0) {
              return {
                ...item,
                items: updateItemRecursively(item.items),
              };
            }
            return item;
          });
        return updateItemRecursively(state);
      });
    }
  }, [addGroupMembers]);

  const checkSubGroupRemove = (id) => {
    let data = {
      groupId: id,
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.CHECK_REMOVE_GROUP,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const updateRemoveGroup = useCallback(() => {
    setDataRemoveGroup((prev) => [prev, ...checkRemoveGroup]);
  }, [checkRemoveGroup]);

  useEffect(() => {
    if (checkRemoveGroup) {
      updateRemoveGroup();
    }
  }, [checkRemoveGroup, updateRemoveGroup]);

  const handleDeleteGroup = (currentExplorer) => {
    setRecordSelected(currentExplorer);
    setIsPopupConfirmDeleteGroupVisible(true);
    setDataRemoveGroup(currentExplorer);
    checkSubGroupRemove(currentExplorer.id);
    setIdParentSelected(currentExplorer.id);
  };

  const handleDeleteMember = (currentExplorer) => {
    setRecordSelected(currentExplorer);
    setIsPopupConfirmDeleteMemberVisible(true);
  };

  const handleUpdate = (id, updatedValue) => {
    let data = {
      namespace,
      name: updatedValue,
      groupId: id,
    };
    let dataObj = {
      appServiceType: SERVICE.UPDATE_GROUP_MEMBER,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
    setExplorerDataList((state) => {
      const updateItemRecursively = (items) =>
        items.map((item) => {
          if (item.id === id) {
            return { ...item, name: updatedValue };
          } else if (item.items && item.items.length > 0) {
            return {
              ...item,
              items: updateItemRecursively(item.items),
            };
          }
          return item;
        });

      return updateItemRecursively(state);
    });
  };

  const handleUpdateNameGroup = (id, updatedValue) => {
    handleUpdate(id, updatedValue);
  };

  const handleOnCancel = () => {
    setValueInput('');
  };

  const onDelete = (id, name) => {
    let data = {
      namespace,
      groupId: idParentSelected,
      accountId: id,
    };
    let dataObj = {
      appServiceType: SERVICE.DELETE_ACCOUNT_GROUP_MEMBER,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));

    setExplorerDataList((state) => {
      const removeItemRecursively = (items, idsToRemove) => {
        return items
          .filter((item) => !idsToRemove.includes(item.accountId))
          .map((item) => {
            if (item.items && item.items.length > 0) {
              return {
                ...item,
                items: removeItemRecursively(item.items, idsToRemove),
              };
            }
            return item;
          });
      };

      const updatedState = removeItemRecursively(state, [id]);
      return updatedState;
    });
    setIsPopupConfirmDeleteMemberVisible(false);
  };

  const handleConfirmDeleteMember = () => {
    setIsPopupConfirmDeleteMemberVisible(false);
    onDelete(recordSelected.accountId);
  };

  const onRemoveGroupMember = useCallback(
    (id) => {
      const collectAllRelatedIds = (items, targetId) => {
        let ids = [];
        items.forEach(({ id: itemId, items }) => {
          if (itemId === targetId) {
            ids.push(itemId);
            if (items?.length) {
              ids = ids.concat(
                items.flatMap(({ id }) => collectAllRelatedIds([id], id)),
              );
            }
          } else if (items?.length) {
            ids = ids.concat(collectAllRelatedIds(items, targetId));
          }
        });
        beeXLogger.debug('ids', ids);
        return ids;
      };

      const relatedIds = collectAllRelatedIds(explorerDataList, id);
      if (!relatedIds.length) return;

      relatedIds.forEach((groupId) => {
        dispatch(
          socketEmitEvent({
            appServiceType: SERVICE.DELETE_GROUP_MEMBER,
            requestId: Date.now(),
            body: JSON.stringify({ groupId, namespace }),
          }),
        );
      });

      setExplorerDataList((state) => {
        const removeItemRecursively = (items, idsToRemove) =>
          items
            .filter(({ id, items }) => !idsToRemove.includes(id))
            .map((item) =>
              item.items?.length
                ? {
                  ...item,
                  items: removeItemRecursively(item.items, idsToRemove),
                }
                : item,
            );

        return removeItemRecursively(state, relatedIds);
      });
    },
    [dispatch, namespace, explorerDataList],
  );

  const handleConfirmDeleteGroup = () => {
    setIsDisabled(true);
    for (let i = 0; i < dataRemoveGroup.length; i++) {
      onRemoveGroupMember(dataRemoveGroup[i].id);
    }
  };

  const handleCancelModal = () => {
    setIsPopupConfirmDeleteGroupVisible(false);
    setIsPopupConfirmDeleteMemberVisible(false);
  };

  useEffect(() => {
    if (deleteGroupMembers?.data?.groupId) {
      const groupId = deleteGroupMembers.data.groupId;

      setQueue((prevQueue) =>
        prevQueue.includes(groupId) ? prevQueue : [...prevQueue, groupId],
      );
    }
  }, [deleteGroupMembers]);

  useEffect(() => {
    if (queue.length === 0) return;

    const groupId = queue[0];

    setProgressMap((prev) => {
      if (prev[groupId] !== undefined) return prev;
      return { ...prev, [groupId]: 0 };
    });

    const interval = setInterval(() => {
      setProgressMap((prev) => {
        const currentProgress = prev[groupId] ?? 0;
        if (currentProgress >= 100) {
          clearInterval(interval);
          setQueue((prevQueue) => {
            const newQueue = prevQueue.slice(1);
            if (newQueue.length === 0) {
              const { data, message, result } = deleteGroupMembers;
              if (result === 1) {
                openMessage(NOTIFIES.SUCCESS, message);
              }
              setIsDisabled(false);
              setIsPopupConfirmDeleteGroupVisible(false);
            }
            return newQueue;
          });
          return { ...prev, [groupId]: 100 };
        }
        return { ...prev, [groupId]: currentProgress + 1 };
      });
    }, 10);

    return () => clearInterval(interval);
  }, [queue, deleteGroupMembers]);

  useEffect(() => {
    if (deleteGroupMembers) {
      const { data, message, result } = deleteGroupMembers;
      const { groupId } = data;
      if (result === 1) {
        setGroupMembers((state) => state?.filter((ip) => ip.id !== groupId));
        setGroupMembersDefault((state) =>
          state?.filter((ip) => ip.id !== groupId),
        );
      } else {
        setGroupMembers((state) =>
          state?.map((item) =>
            item.id !== groupId ? item : { ...item, loading: false },
          ),
        );
        setGroupMembersDefault((state) =>
          state?.map((item) =>
            item.id !== groupId ? item : { ...item, loading: false },
          ),
        );
      }
    }
  }, [deleteGroupMembers]);

  useEffect(() => {
    if (updateGroupMembers && groupMembers && groupMembers.length > 0) {
      const { message, result } = updateGroupMembers;
      let data1 = [...groupMembers];
      if (result === 1) {
        openMessage(NOTIFIES.SUCCESS, message);
        if (
          updateGroupMembers &&
          updateGroupMembers.data &&
          updateGroupMembers.data.group &&
          updateGroupMembers.data.group.id
        ) {
          groupMembers.map((item, index) => {
            if (item.id === updateGroupMembers.data.group.id) {
              data1[index] = {
                ...updateGroupMembers.data.group,
                index: item.index,
              };
            }
          });
          setGroupMembers(data1);
          setGroupMembersDefault(data1);
        }
      } else {
        openMessage(NOTIFIES.ERROR, message);
      }
    }
  }, [updateGroupMembers]);

  useEffect(() => {
    if (accountByNamespace && accountGroupMembers) {
      const members = accountByNamespace?.filter((item) => {
        return accountGroupMembers?.some(
          (member) => member.accountId === item.accountId,
        );
      });
      setMembersGroup(members);
    }
    if (listGroupByParentGroup?.groups?.length > 0) {
      dispatch(clearGroupAccountMember());
      dispatch(clearListGroupByParentGroup());

      const additionalGroups = listGroupByParentGroup.groups;

      setMembersGroup((prevMembersGroup) => [
        ...(prevMembersGroup || []),
        ...additionalGroups,
      ]);
    }
  }, [accountByNamespace, listGroupByParentGroup]);

  useEffect(() => {
    console.log("🚀 ~ GroupMembersTab ~ listGroupMembers:", listGroupMembers);
    if (listGroupMembers && Array.isArray(listGroupMembers) && listGroupMembers.length > 0) {
      const dataTemp = listGroupMembers.map((groupMemberItem, index) => ({
        ...groupMemberItem,
        index: index + 1,
        loading: false,
        isFolder: true,
      }));
      setGroupMembers(dataTemp);

      if (searchValue?.trim()) {
        const searchItems = dataTemp.map((item) => ({
          id: item.id,
          name: item.name,
          isFolder: true,
          items: [],
          parentGroupId: item.parentGroupId,
        }));
        setExplorerDataList(searchItems);
      } else {
        const rootItems = dataTemp
          .filter((item) => item.parentGroupId === -1)
          .map((item) => ({
            id: item.id,
            name: item.name,
            isFolder: true,
            items: [],
            parentGroupId: item.parentGroupId,
          }));
        setExplorerDataList(rootItems);
        setGroupMembersDefault(dataTemp);
      }
    } else if (listGroupMembers && Array.isArray(listGroupMembers) && listGroupMembers.length === 0) {
      setGroupMembers([]);
      setExplorerDataList([]);
    }
  }, [listGroupMembers, searchValue]);

  useEffect(() => {
    if (isAuth === 1 && namespace && isAdmin) {
      let data = {
        namespace
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_GROUP_MEMBER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAdmin, isAuth, namespace]);

  const onCancelGroupMember = () => {
    setVisibleAddGroupMembers(false);
    setKey(Math.random());
  };

  const handleAddGroupMemberDone = useCallback((data) => {
    setVisibleAddGroupMembers(false);
    setKey(Math.random());
    setGroupMembersDefault((state) =>
      state && state.length > 0
        ? state.concat({
          index: state.length + 1,
          id: (data.group && data.group.id) || '',
          name: (data.group && data.group.name) || '',
          namespace: (data.group && data.group.namespace) || '',
          loading: false,
        })
        : [
          {
            index: 1,
            id: (data.group && data.group.id) || '',
            name: (data.group && data.group.name) || '',
            namespace: (data.group && data.group.namespace) || '',
            loading: false,
          },
        ],
    );
    return setGroupMembers((state) =>
      state && state.length > 0
        ? state.concat({
          index: state.length + 1,
          id: (data.group && data.group.id) || '',
          name: (data.group && data.group.name) || '',
          namespace: (data.group && data.group.namespace) || '',
          loading: false,
        })
        : [
          {
            index: 1,
            id: (data.group && data.group.id) || '',
            name: (data.group && data.group.name) || '',
            namespace: (data.group && data.group.namespace) || '',
            loading: false,
          },
        ],
    );
  }, []);

  const onUpdateGroupMembers = (
    requestId,
    values,
    groupId,
    groupNameDefault,
  ) => {
    let data = {
      namespace,
      name: values?.name ?? groupNameDefault,
      groupId,
    };
    let dataObj = {
      appServiceType: SERVICE.UPDATE_GROUP_MEMBER,
      requestId,
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
    setVisibleAddGroupMembers(false);
    setKey(Math.random());
  };

  const onAddMemberGroup = (group, item) => {
    const listAccounts = Array.isArray(accountByNamespaceData)
      ? accountByNamespaceData
      : (accountByNamespaceData?.data || accountByNamespace || []);
    const foundAccount = listAccounts.find(
      (acc) => acc.accountId === item.accountId,
    );

    if (!foundAccount) return;

    let data = {
      namespace,
      groupId: group.id,
      accountId: foundAccount.accountId,
      indexOf: group.index + 1,
    };

    let dataObj = {
      appServiceType: SERVICE.ADD_ACCOUNT_GROUP_MEMBER,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };

    dispatch(socketEmitEvent(dataObj));

    setExplorerDataList((state) => {
      const addAccountToGroup = (items) => {
        return items.map((itemNode) => {
          const updatedItems = itemNode.items || [];

          if (itemNode.id === group.id) {
            const isExist = updatedItems.some(
              (member) => member.accountId === foundAccount.accountId,
            );

            return {
              ...itemNode,
              items: isExist
                ? updatedItems
                : updatedItems.concat({
                  accountId: foundAccount.accountId,
                  fullName: foundAccount.fullName,
                  index: (itemNode.index || 0) + 1,
                }),
            };
          }

          if (updatedItems.length > 0) {
            return {
              ...itemNode,
              items: addAccountToGroup(updatedItems),
            };
          }

          return itemNode;
        });
      };

      return addAccountToGroup(state);
    });
  };

  const onExpandData = (record) => {
    setRecordSelected(record);
    setIdParentSelected(record.id);
  };

  const onCreateGroupMembers = (requestId, values, dataList) => {
    let data = {
      namespace,
      name: values.name || values,
      parentGroupId: idParentSelected ? idParentSelected : -1,
      accountInfos:
        dataList &&
        dataList.length > 0 &&
        dataList.map((item, index) => ({
          accountId: item.accountId,
          indexOf: index + 1,
        })),
    };

    let dataObj = {
      appServiceType: SERVICE.ADD_GROUP_MEMBER,
      requestId,
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
    setValueInput('');
    if (idParentSelected) {
      onExpandData(recordSelected);
    }
  };

  useEffect(() => {
    if (
      addGroupMembers &&
      addGroupMembers.result === 1 &&
      idParentSelected === null
    ) {
      setExplorerDataList((state) => [
        ...state,
        {
          id: addGroupMembers.data.group.id,
          name: addGroupMembers.data.group.name,
          isFolder: true,
          items: [],
        },
      ]);
    }
  }, [addGroupMembers]);

  const findAndSetLoading = (data, id, isLoading) => {
    return data.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          isLoading:
            typeof item.isLoading === 'boolean' ? isLoading : isLoading,
        };
      } else if (item.items && item.items.length > 0) {
        return {
          ...item,
          items: findAndSetLoading(item.items, id, isLoading),
        };
      }
      return item;
    });
  };

  const onHandleExpand = useCallback(
    (id) => {
      setIdParentSelected(id);
      setExplorerDataList((state) => findAndSetLoading(state, id, true));
      const timestamp = new Date().getTime();
      const groupData = {
        namespace,
        groupId: id,
      };
      dispatch(
        socketEmitEvent({
          appServiceType: SERVICE.LIST_ACCOUNT_GROUP_MEMBER,
          requestId: timestamp,
          body: JSON.stringify(groupData),
        }),
      );

      const subGroupData = {
        namespace,
        parentGroupId: id,
      };
      dispatch(
        socketEmitEvent({
          appServiceType: SERVICE.LIST_GROUP_BY_PARENT_GROUP,
          requestId: timestamp,
          body: JSON.stringify(subGroupData),
        }),
      );
    },
    [dispatch, namespace],
  );

  const updateExplorerDataList = useCallback(
    (data, parentId, updatedMembers) => {
      return data.map((item) => {
        if (item.id === parentId) {
          return { ...item, items: updatedMembers };
        } else if (item.items && item.items.length > 0) {
          return {
            ...item,
            items: updateExplorerDataList(item.items, parentId, updatedMembers),
          };
        }

        return item;
      });
    },
    [],
  );

  useEffect(() => {
    if (!idParentSelected || !membersGroup || membersGroup.length === 0) {
      return;
    }

    const updatedMembers = membersGroup.map((member) => ({
      ...member,
      isFolder: member.parentGroupId != null && member.parentGroupId !== -1,
    }));

    setExplorerDataList((prevDataList) =>
      updateExplorerDataList(prevDataList, idParentSelected, updatedMembers),
    );
    dispatch(clearGroupAccountMember());
    dispatch(clearListGroupByParentGroup());
  }, [idParentSelected, membersGroup, updateExplorerDataList]);

  const onSearchGroupMember = (name) => {
    setGroupMemberTabLoading(true);
    const keyword = name?.trim() || '';
    setSearchValue(keyword);

    if (keyword) {
      const dataName = removeAccents(keyword.toLowerCase());
      const dataSearch =
        groupMembersDefault?.filter((item) =>
          removeAccents(item.name?.toLowerCase())?.includes(dataName),
        ) ?? [];

      if (dataSearch.length > 0) {
        const searchItems = dataSearch.map((item) => ({
          id: item.id,
          name: item.name,
          isFolder: true,
          items: [],
          parentGroupId: item.parentGroupId,
        }));
        setGroupMembers(dataSearch);
        setExplorerDataList(searchItems);
      } else {
        setExplorerDataList([]);
      }

      let data = {
        subName: keyword,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.SEARCH_GROUP_BY_NAME,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    } else {
      const rootItems =
        groupMembersDefault
          ?.filter((item) => item.parentGroupId === -1)
          .map((item) => ({
            id: item.id,
            name: item.name,
            isFolder: true,
            items: [],
            parentGroupId: item.parentGroupId,
          })) || [];
      setGroupMembers(groupMembersDefault || []);
      setExplorerDataList(rootItems);

      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_GROUP_MEMBER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }

    setTimeout(() => {
      setGroupMemberTabLoading(false);
    }, 400);
  };

  useEffect(() => {
    if (searchKeyword && currentTab === 'group-members') {
      setSearchValue(searchKeyword);
      onSearchGroupMember(searchKeyword);
      if (setSearchKeyword) {
        setSearchKeyword('');
      }
    }
  }, [searchKeyword, currentTab]);

  return (
    <Fragment>
      <Modal
        className="modal-detail-notification"
        title={`Do you want to delete ${recordSelected?.fullName}?`}
        visible={isPopupConfirmDeleteMemberVisible}
        onCancel={handleCancelModal}
        style={{ top: 50 }}
        width="920px"
        bodyStyle={{ textAlign: 'center' }}
        footer={[
          <Button
            key="next"
            onClick={handleConfirmDeleteMember}
            style={{
              color: 'red',
              borderColor: 'red',
            }}
          >
            {t('Delete')}
          </Button>,
          <Button key="back" onClick={handleCancelModal}>
            {t('Close')}
          </Button>,
        ]}
      />

      <Modal
        className="modal-detail-notification"
        title={t('_CONFIRM_REMOVE_GROUP', {
          name: recordSelected?.name,
        })}
        visible={isPopupConfirmDeleteGroupVisible}
        onCancel={!isDisabled ? handleCancelModal : null}
        style={{
          top: 50,
        }}
        width="920px"
        bodyStyle={{ textAlign: 'center' }}
        footer={[
          <Button
            key="next"
            onClick={handleConfirmDeleteGroup}
            style={{
              color: 'red',
              borderColor: 'red',
            }}
          >
            {t('Delete')}
          </Button>,
          <Button
            key="back"
            onClick={handleCancelModal}
            style={{
              opacity: isDisabled ? 0.5 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              pointerEvents: isDisabled ? 'none' : 'auto',
            }}
          >
            {t('Close')}
          </Button>,
        ]}
      >
        <div style={{ fontSize: '20px', textAlign: 'start' }}>
          List sub groups
        </div>
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '8px',
          }}
        >
          <thead style={{ marginBottom: '10px' }}>
            <tr style={{ borderBottom: '1px solid #3c3c3c' }}>
              <th
                style={{
                  padding: '12px 20px',
                  textAlign: 'left',
                  borderBottom: '1px solid #3c3c3c',
                  width: '50%',
                }}
              >
                Name
              </th>
              <th
                style={{
                  padding: '12px 20px',
                  textAlign: 'left',
                  borderBottom: '1px solid #3c3c3c',
                }}
              >
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(dataRemoveGroup) &&
              dataRemoveGroup.length > 0 &&
              dataRemoveGroup.map((item) => {
                const progress = progressMap[item.id] || 0;

                return (
                  <tr key={item.id} style={{ border: '1px solid #3c3c3c' }}>
                    <td style={{ padding: '16px 20px', textAlign: 'start' }}>
                      {item.name}
                    </td>
                    <td
                      style={{
                        textAlign: 'start',
                      }}
                    >
                      {progress === 0 ? (
                        <span
                          style={{
                            color: '#7b7b7b',
                            border: `1px solid #7b7b7b`,
                            padding: '6px 12px',
                            width: '92px',
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          -
                        </span>
                      ) : progress === 100 ? (
                        <span
                          style={{
                            color: '#fff',
                            border: `1px solid transparent`,
                            backgroundColor: '#4f4d4d',
                            padding: '6px 12px',
                            width: '92px',
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          Deleted
                        </span>
                      ) : (
                        <span
                          style={{
                            color: '#e0b359',
                            border: `1px solid #e0b359`,
                            padding: '6px 12px',
                            width: '92px',
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          Deleting...
                        </span>
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </Modal>

      <Modal
        visible={visibleGroupMembers}
        title={
          dataArr && dataArr.name
            ? t('Update group members')
            : t('Add group members')
        }
        onCancel={() => onCancelGroupMember()}
        footer={null}
      >
        {visibleGroupMembers && (
          <AddGroupMember
            key={key}
            dataGroup={accountByNamespace}
            namespaceGroup={namespace}
            dataDevice={dataArr}
            onUpdateGroup={onUpdateGroupMembers}
            onCreateGroup={onCreateGroupMembers}
            onDone={handleAddGroupMemberDone}
          />
        )}
      </Modal>

      {currentTab === 'group-members' && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            paddingBottom: '5px',
          }}
        >
          <Search
            placeholder={t('Search by name')}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onSearch={(val) => {
              setSearchValue(val);
              onSearchGroupMember(val);
            }}
            loading={groupMemberTabLoading}
            style={{ width: 240, marginRight: '16px' }}
            allowClear
          />
        </div>
      )}
      <div className="App">
        <div className="folderContainerBody">
          <div className="folder-container">
            {explorerDataList?.map(
              (explorerData) =>
                explorerData && (
                  <Folder
                    key={explorerData.id}
                    handleAddNewGroup={handleAddNewGroup}
                    handleDeleteGroup={handleDeleteGroup}
                    handleDeleteMember={handleDeleteMember}
                    handleUpdateNameGroup={handleUpdateNameGroup}
                    explorerData={explorerData}
                    onHandleExpand={onHandleExpand}
                    onAddMemberGroup={onAddMemberGroup}
                  />
                ),
            )}
          </div>
        </div>
      </div>
      <div className="new-group">
        <div>
          <VscFolder color="#0e9347" />
          <input
            type="text"
            onFocus={handleFocus}
            value={valueInput}
            onChange={handleInputChange}
            placeholder="Add new group..."
            style={{ marginLeft: '4px' }}
            onKeyDown={onAdd}
          />
        </div>
        <div>
          <button
            onClick={onAdd}
            style={{
              marginRight: '8px',
              backgroundColor: '#000',
              color: '#0e9347',
            }}
          >
            Create
          </button>
          <button
            style={{ backgroundColor: '#000', color: '#4f4d4d' }}
            onClick={handleOnCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default GroupMembersTab;
